module.exports = __webpack_public_path__ + "assets/be8eb5898d2f773431b8d1e304321291.woff";